import React from 'react';
import PropTypes from 'prop-types';

// Mixin / Modules
import { isEmptyObject } from '../../../../../../../modules/global';

// Related Components
import ApplyButton from './apply_button';

export default class Engagement extends React.PureComponent {
  static propTypes = {
    opportunity: PropTypes.object.isRequired,
    engagement: PropTypes.object.isRequired,
  }

  render() {
    const { opportunity, engagement } = this.props;

    return (
      <React.Fragment>
        {
          !isEmptyObject(engagement) &&
          <div className='secondary-color sm-font'>
            {engagement.status}
          </div>
        }
        {
          (isEmptyObject(engagement) && !opportunity.is_closed) &&
          <ApplyButton opportunity={opportunity} />
        }
      </React.Fragment>
    )
  }
}